module.exports = __webpack_public_path__ + "assets/img/tit1.51824039.png";